import apiFetch from '../apiFetch'

export default function (token, entityTypeId) {
  return apiFetch({ endPoint: `entitySubType?entityTypeId=${entityTypeId}`, method: 'GET', body: null, token: token })
}
